var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.482,
    height: 11.039,
    viewBox: "0 0 14.482 11.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M5134.089,33.4a11.937,11.937,0,0,0-2.948-.915.045.045,0,0,0-.047.023,8.352,8.352,0,0,0-.367.754,11,11,0,0,0-3.311,0,7.58,7.58,0,0,0-.373-.754.045.045,0,0,0-.047-.023,11.9,11.9,0,0,0-2.948.915.048.048,0,0,0-.02.016,12.227,12.227,0,0,0-2.139,8.243.045.045,0,0,0,.019.034,11.987,11.987,0,0,0,3.616,1.828.048.048,0,0,0,.051-.016,8.682,8.682,0,0,0,.74-1.2.046.046,0,0,0-.025-.063,7.958,7.958,0,0,1-1.13-.539.046.046,0,0,1-.005-.077c.076-.057.152-.116.225-.176a.043.043,0,0,1,.046-.006,8.568,8.568,0,0,0,7.279,0,.043.043,0,0,1,.047.006c.073.059.149.119.225.176a.046.046,0,0,1,0,.077,7.472,7.472,0,0,1-1.13.538.047.047,0,0,0-.025.064,9.7,9.7,0,0,0,.739,1.2.046.046,0,0,0,.051.017,11.943,11.943,0,0,0,3.622-1.828.045.045,0,0,0,.019-.033,12.144,12.144,0,0,0-2.141-8.243A.034.034,0,0,0,5134.089,33.4Zm-7.42,6.614a1.469,1.469,0,0,1,0-2.919,1.469,1.469,0,0,1,0,2.919Zm4.812,0a1.469,1.469,0,0,1,0-2.919,1.469,1.469,0,0,1,0,2.919Z",
    transform: "translate(-5121.83 -32.48)",
    fill: "#98a9b8",
    opacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.4f93a92236eb1f1467d2bf97421eb818.svg";
export { ForwardRef as ReactComponent };